import { render, staticRenderFns } from "./TakeAwayMenuCartPanelPromotionProduct.vue?vue&type=template&id=43fb0ca2&"
import script from "./TakeAwayMenuCartPanelPromotionProduct.vue?vue&type=script&lang=ts&"
export * from "./TakeAwayMenuCartPanelPromotionProduct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports